/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import _axios, { AxiosError, AxiosRequestConfig } from 'axios'
import _useSWR, { mutate } from 'swr'
import { PUBLIC_SITE_URL } from '../envBranch'

const client = _axios.create({
  baseURL: `${PUBLIC_SITE_URL}/customer`,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  responseType: 'json',
})
client.defaults.timeout = 5000 // ms

export const API = {
  get: async (url: string, config?: AxiosRequestConfig): Promise<any> => {
    const response = await client.get(url, config).catch((err: AxiosError) => Promise.reject(err))
    return response?.data
  },
  post: async (url: string, data?: any, config?: AxiosRequestConfig): Promise<any> => {
    const response = await client.post(url, data, config).catch((err: AxiosError) => Promise.reject(err))
    return response?.data
  },
  put: async (url: string, data?: any, config?: AxiosRequestConfig): Promise<any> => {
    const response = await client.put(url, data, config).catch((err: AxiosError) => Promise.reject(err))
    return response?.data
  },
  delete: async (url: string, config?: AxiosRequestConfig): Promise<any> => {
    const response = await client.delete(url, config).catch((err: AxiosError) => Promise.reject(err))
    return response?.data
  },
}

export const fetcher = (url: string, config?: AxiosRequestConfig) => {
  return API.get(url, config)
    .then((res) => res)
    .catch((err) => err.code) // HOPE: SWR 使うと接続エラーが取得できないので無理やりハンドリング。 data に ECONNABORTED が入ってしまうので、きれいにしたい
}

export const useSWR = <T>(url: string, idToken?: string) => {
  const { data, error } = _useSWR<T, any>(url, () => fetcher(url, { headers: { Authorization: idToken } }), {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  })

  return {
    data,
    error,
    mutate: (updatedData?: T) =>
      mutate<T>(url, updatedData ? { ...data, ...updatedData } : undefined, updatedData ? false : true),
  }
}
